import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(theme => ({
  filtersContainer: {
    marginBottom: theme.spacing(2),
		position: 'relative',
    backgroundCoulour: 'red'
  },
  filtersTitle: {
    textTransform: 'uppercase',
    marginBottom: theme.spacing(1),
  },
  filtersCheckboxRoot: {
    display: 'flex',
		flexDirection: 'column',
  },
  filtersCheckboxLabel: {
    display: 'flex',
    alignItems: 'center',
		gap: theme.spacing(0.5),
  },
  projectCell: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
    '& a': {
      textDecoration: 'none',
      '&:hover': {
        textDecoration: 'none',
      },
    },
  },
  projectCellIcon: {
    verticalAlign: 'middle',
    opacity: 0.7,
	},
}));
